export const SIGNUP_PASSWORD = "signUpPassword";
export const SIGNIN_PASSWORD = "password";
export const CONFIRM_PASSWORD = "confirmPassword";
export const EMAIL = "email";
export const NAME = "name";
export const SURNAME = "surname";
export const NEW_PASSWORD = "newPassword";
export const CONFIRM_NEW_PASSWORD = "confirmNewPassword";
